import React, { FC, ReactNode } from 'react'
import i18n from 'i18next'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import defaultImg from 'assets/images/mall/collect_empty.png'
import './index.scss'
import { useHistoryNew } from '@utils'

const { codeType } = Config

// interface
interface IProps extends RouteComponentProps {
}

const Empty: FC<IProps> = () => {
  const history = useHistoryNew()

  return (
    <div className='collect-empty-wrapper'>
      <div className='collect-empty-wrap'>
        <img src={defaultImg} />
        <p>{i18n.t('favorite.emptyTip')}</p>
        <div className='back-btn' onClick={() => history.goBack()}>{i18n.t('favorite.backMall')}</div>
      </div>
    </div>
  )
}

export default withRouter(Empty)
